import { Component, OnInit } from '@angular/core';
import { Entity } from '../select-list/select-list.component';
import { ApiService } from '../../api.service';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-specimen-sources',
  templateUrl: './specimen-sources.component.html',
  styleUrls: ['./specimen-sources.component.css']
})
export class SpecimenSourcesComponent implements OnInit {
  public title : string;
  constructor(public api : ApiService) 
  {
  }

  ngOnInit() {
  }

  get items(){
    return this.api.session.specimenSources;
  }

  get selectedItems(){
    return this.api.session.currentCriteria.specimenSources.selectedItems;
  }
  set selectedItems(value){
    MyUtility.scrubChildren(value);
    this.api.session.currentCriteria.specimenSources.selectedItems = value;
  }

  clearCurrent(){
    this.api.session.currentCriteria.specimenSources = MyUtility.deepCopy(this.api.originalCriteria.specimenSources);
  }
}
